import React from 'react';
import {Switch, SwitchGroupProps} from '@mantine/core';

export const EtroSwitchGroup: React.FC<SwitchGroupProps> = props => {
  return <Switch.Group {...props} />;
};
